<template>
  <b-form-group>
    <slot name="label">
      <div>
        <label :for="`${id}`" class="col-form-label pt-0"> {{ label }} </label>
      </div>
    </slot>
    <div class="position-relative">
      <b-form-input
        :id="`${id}`"
        :type="showPassword ? 'text' : 'password'"
        :required="required"
        :disabled="disabled"
        :value="value"
        :size="size"
        @input.native="$emit('input', $event.target.value)"
        :placeholder="placeholder"
        :state="state"
      />
      <button
        v-if="passwordToggle"
        type="button"
        class="toggle-password"
        @click="togglePassword()"
      >
        <svg-icon v-if="showPassword" icon="eye-close" class="icon-lg" />
        <svg-icon v-else icon="eye" class="icon-lg" />
      </button>
    </div>
    <password-security
      v-show="strengthCheck"
      :password="value"
      @password-security="emitPasswordSecurity"
    />
  </b-form-group>
</template>

<script>
import PasswordSecurity from '@/components/Forms/PasswordSecurity.vue';
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    passwordToggle: {
      type: Boolean,
      default: true
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    strengthCheck: {
      type: Boolean,
      default: false
    }
  },

  components: {
    PasswordSecurity
  },

  data() {
    return {
      showPassword: false
    };
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    emitPasswordSecurity({ isSecure }) {
      this.$emit('password-security', { isSecure });
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-password {
  background: none;
  border: none;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  outline: none;
  margin-top: -1px;
  cursor: pointer;
  color: $lighten;

  &:hover {
    color: $primary;
  }
}
</style>
